import React, { useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { orchard } from '../theme';

/* Collapsible FAQ list — hairline dividers, rotating plus, one open at a time. */
export default function Faq({ items, accent = orchard.cherry }) {
  const [open, setOpen] = useState(0);

  return (
    <Box>
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <Box
            key={item.q}
            sx={{ borderBottom: '1px solid rgba(36,30,43,0.1)' }}
          >
            <Box
              component="button"
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              aria-expanded={isOpen}
              sx={{
                all: 'unset',
                boxSizing: 'border-box',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                width: '100%',
                py: 2.5,
                '&:focus-visible': {
                  outline: `2px solid ${accent}`,
                  outlineOffset: 2,
                  borderRadius: 1,
                },
                '&:hover .cp-faq-q': { color: accent },
              }}
            >
              <Typography
                className="cp-faq-q"
                sx={{
                  fontWeight: 700,
                  fontSize: '1.02rem',
                  color: isOpen ? accent : orchard.ink,
                  transition: 'color 0.2s ease',
                }}
              >
                {item.q}
              </Typography>
              <AddIcon
                sx={{
                  flexShrink: 0,
                  fontSize: 20,
                  color: isOpen ? accent : 'text.secondary',
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  transition: 'transform 0.25s cubic-bezier(0.22,1,0.36,1)',
                }}
              />
            </Box>
            <Collapse in={isOpen} timeout={260}>
              <Typography
                sx={{
                  pb: 2.5,
                  pr: 5,
                  color: 'text.secondary',
                  lineHeight: 1.65,
                  fontSize: '0.97rem',
                }}
              >
                {item.a}
              </Typography>
            </Collapse>
          </Box>
        );
      })}
    </Box>
  );
}
